module.exports = __webpack_public_path__ + "static/media/cert_160.682c2457.jpg";